<div class="message-container">
  <p data-testid="further-assistance-text">
      Need help? Call {{ (client$ | async)?.clientName }}: <span
          class="phoneNumber" data-testid="further-assistance-ph"><a href="tel:{{ (client$ | async)?.supportPhoneNumber | phone }}">{{ (client$ | async)?.supportPhoneNumber | phone }}</a></span>
  </p>
</div>
